import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { workflowBuilderComponent } from './workflow-builder/workflow-builder.component';
import { workflowComponent } from './workflow/workflow.component';
import { MsalGuard } from '@azure/msal-angular';
import { OverageComponent } from './overage/overage.component';
import { GroupGuardService } from './services/group-guard.service';
import { customComponent } from './custom-component/custom.component';
import { environment } from 'src/environments/environment';

let enValue = environment;

const routes: Routes = [
  {
    path: 'overage',
    component: OverageComponent,
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'Workflow',
    component: workflowComponent,
    canActivate: [
      MsalGuard,
      GroupGuardService
    ],
    data: {
      expectedGroups: [
        enValue.groups_client_PlatformAdminGroupId,
        enValue.groups_client_FlowsheetBuilderUserGroupId
      ]
    }
  },
  {
    path: 'custom-function',
    component: customComponent,
    canActivate: [
      MsalGuard,
      GroupGuardService
    ],
    data: {
      expectedGroups: [
        enValue.groups_client_PlatformAdminGroupId,
        enValue.groups_client_FlowsheetBuilderUserGroupId
      ]
    }
  },
  {
    path: 'Workflow/:id/:workflowName',
    component: workflowComponent,
    canActivate: [
      MsalGuard
    ],
    data: {
      expectedGroups: [
        enValue.groups_client_PlatformAdminGroupId,
        enValue.groups_client_FlowsheetBuilderUserGroupId
      ]
    }
  },
  {
    path: 'Workflow/:workflowName',
    component: workflowComponent,
    canActivate: [
      MsalGuard
    ],
    data: {
      expectedGroups: [
        enValue.groups_client_PlatformAdminGroupId,
        enValue.groups_client_FlowsheetBuilderUserGroupId
      ]
    }
  },
  {
    path: 'workflowBuilder',
    component: workflowBuilderComponent,
    canActivate: [
      MsalGuard,
      GroupGuardService
    ],
    data: {
      expectedGroups: [
        enValue.groups_client_PlatformAdminGroupId,
        enValue.groups_client_FlowsheetBuilderUserGroupId
      ]
    }
  },
  {
    path: 'workflowBuilder:id:edit',
    component: workflowBuilderComponent,
    canActivate: [
      MsalGuard,
      GroupGuardService
    ],
    data: {
      expectedGroups: [
        enValue.groups_client_PlatformAdminGroupId,
        enValue.groups_client_FlowsheetBuilderUserGroupId
      ]
    }
  },
  {
    path: '**',
    redirectTo: 'Workflow',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes), RouterModule.forRoot(routes, {
    useHash: false, onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
